import React, { useContext, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { EquipamentosContext } from 'contexts/EquipamentosContext';
import { RelatoriosContext } from 'contexts/RelatoriosContext';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { useDialog, useModal } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import DeleteModal from 'components/Modals/DeleteModal';
import EquipamentoModal from 'components/Modals/EquipamentoModal';
import FullEquipamentoModal from 'components/Modals/FullEquipamentoModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import DataView, { useDataViewFilters } from 'components/DataView';
import getEquipamentosFilterFields from './filterFields';

const Equipamentos = () => {
  const rotina = 'Equipamento';
  const titulo = 'Equipamentos';
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { openDialog, closeDialog } = useDialog();
  const { openModal, closeModal } = useModal();
  const { equipamentos, getEquipamentos, getLoading } =
    useContext(EquipamentosContext);
  const { exportPdf, exportXls, deleteGrid } = useContext(GridContext);
  const { getURLRelatorio } = useContext(RelatoriosContext);
  const { drops } = useContext(DropsContext);
  const filterFields = useMemo(
    () => getEquipamentosFilterFields(drops),
    [drops]
  );

  const { applyFilter, filterForm } = useDataViewFilters({
    fields: filterFields,
    searchParams,
    setSearchParams,
    onApply: (props) => loadGrid(props),
  });
  const { getValues } = filterForm;

  const loadGrid = (props = {}) => {
    const filter = props?.filter || getValues();
    closeModal();
    closeDialog();
    getEquipamentos({ ...props, rotina, filter });
  };

  const toolbarActions = [
    {
      name: 'Adicionar',
      icon: 'add',
      placement: 'primary',
      action: () =>
        openDialog(
          <FullEquipamentoModal callback={loadGrid} />,
          'Cadastrar Equipamento'
        ),
    },
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({ rotina, filter: getValues(), order: equipamentos?.order }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({ rotina, filter: getValues(), order: equipamentos.order }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={equipamentos?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
  ];

  const rowActions = [
    {
      name: 'Editar',
      icon: 'edit',
      action: ({ row }) =>
        openDialog(
          <EquipamentoModal callback={loadGrid} equipamento={row} />,
          'Editar Equipamento'
        ),
    },
    {
      name: 'Deletar',
      icon: 'delete',
      action: ({ row }) =>
        openModal(
          <DeleteModal
            onSubmit={() =>
              deleteGrid({
                params: { id: row?.id, rotina },
                cb: loadGrid,
              })
            }
          />
        ),
    },
    {
      name: 'Histórico de manutenção',
      icon: 'description',
      menu: true,
      action: ({ row }) =>
        getURLRelatorio({
          data: { codigo: 'HME0000001', equipamento_id: row?.id },
        }),
    },
    {
      name: 'Relacionados',
      icon: 'splitscreen',
      menu: true,
      action: ({ row }) =>
        navigate(`/app/Equipamentos/Relacionados/${row?.id}`),
    },
  ];

  return (
    <Container fillHeight>
      <Header rotina={rotina} titulo={titulo} colunas={equipamentos?.colunas} />
      <Card fillHeight>
        <DataView
          fillHeight
          grid={equipamentos}
          filterFields={filterFields}
          filterForm={filterForm}
          onFilter={applyFilter}
          toolbarActions={toolbarActions}
          rowActions={rowActions}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
        />
      </Card>
    </Container>
  );
};

export default Equipamentos;
